import { Component, Input, OnInit } from "@angular/core";
import { AppConfig } from "src/app/configs/app.config";
import { TdspCommonService } from "src/app/core/services/tdsp/tdsp-common.service";

@Component({
  selector: "app-kpi-pyramid",
  templateUrl: "./kpi-pyramid.component.html",
  styleUrl: "./kpi-pyramid.component.scss",
})
export class KpiPyramidComponent implements OnInit {
  awarenessColor: string = "darkblue";
  considerationColor: string = "purple";
  conversionColor: string = "darkgreen"

  @Input() kpis = [];

  steps = [
    {
      label: "Awareness",
      description: "Top of funnel content that drives interest",
    },
    {
      label: "Consideration",
      description: "Nurturing leads to evaluate solutions",
    },
    { label: "Conversion", description: "Turning leads into paying customers" },
  ];
  constructor(public tdspCommonService: TdspCommonService) {}

  ngOnInit(): void {
  }

}
